import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { getIdentityActiveRoleName, getIdentityStage, isUser } from 'store/entities/identity/selectors'
import { changeWindowSizes } from 'store/entities/ui/actions'
import { modal } from 'store/entities/modal/actions'
import ProtrackConfirmationModal from 'app/domains/common/Modals/ProtrackConfirmationModal'
import { setBlockedPathname } from 'store/entities/protracks/unsavedChanges/actions'
import App from './App'

const mapStateToProps = state => ({
  role: getIdentityActiveRoleName(state),
  stage: getIdentityStage(state),
  isUser: isUser(state),
})
const mapDispatchToProps = {
  changeWindowSizes,
  showModal: modal.show,
  hideModal: modal.hide,
  setBlockedPathname,
}

const mergeProps = (stateProps, { showModal, ...dispatchProps }, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  showConfirmationModal: props => showModal(ProtrackConfirmationModal, { size: 'mm', ...props }),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(App))
